const module = {
  config: {
    name: "print",
    svg: "../static/img/icon/menu/printer-fill.svg",
    desc: "Berisi modul print perpustakaan.",
    layout: false
  },
  routes: [
    // Print Kartu Anggota Portrait
    {
      name: "Kartu Anggota Portrait",
      icon: "ri-id-card-fill",
      path: "/kartu-anggota-portrait",
      component: () => import("./member-card-portrait.vue"),
      separator: "Print Kartu Anggota"
    },
    // Print Kartu Anggota Landscape
    {
      name: "Kartu Anggota Landscape",
      icon: "ri-id-card-fill",
      path: "/kartu-anggota-landscape",
      component: () => import("./member-card-landscape.vue"),
      separator: "Print Kartu Anggota"
    },
    // Print Barcode Buku Portrait
    {
      name: "Barcode Buku Portrait",
      icon: "ri-barcode-fill",
      path: "/barcode-buku-portrait",
      component: () => import("./book-barcode-portrait.vue"),
      separator: "Print Barcode Buku"
    },
    // Print Barcode Buku Landscape
    {
      name: "Barcode Buku Landscape",
      icon: "ri-barcode-fill",
      path: "/barcode-buku-landscape",
      component: () => import("./book-barcode-landscape.vue"),
      separator: "Print Barcode Buku"
    },
    // Print Label Punggung Buku (Nomor Panggil)
    {
      name: "Label Buku (Nomor Panggil)",
      icon: "ri-price-tag-3-fill",
      path: "/label-buku",
      component: () => import("./book-spine-label.vue"),
      separator: "Print Label Buku"
    },
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/print/_index.js